module.exports = __webpack_public_path__ + "static/media/remise.adde668b.svg";